export const postQuery = async (url, query, variables = {}) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
      console.error(`HTTP error! status: ${response.status}`);
      return { response: response.status, error: await response.text() };
    }

    const data = await response.json();
    return { statusCode: 200, data: data.data };
  } catch (error) {
    console.error("Error in postQuery:", error);
    return { statusCode: 400, error };
  }
};
